export default __webpack_public_path__ + "static/media/Timofey-Kuznetsov.05e28bab.png";